import React from "react"
import propTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import TicketDetail from "./TicketDetail"

const ModalTicket = ({ isOpen, toggle, selectedTicket }) => {
    // Componente modal para mostrar los detalles de un ticket seleccionado
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered={true}
            style={{ maxWidth: "500px", width: "95%" }}
            backdrop={true}
        >
            <ModalHeader toggle={toggle} charcode="X">
                {selectedTicket ? `Detalles del Ticket ${selectedTicket.folio}` : "Detalles del Ticket"}
            </ModalHeader>
            <ModalBody style={{ padding: "0px", maxHeight: "70vh", overflowY: "auto" }}>
                <TicketDetail ticket={selectedTicket} toggle={toggle} />
            </ModalBody>
        </Modal>
    )
}

ModalTicket.propTypes = {
  isOpen: propTypes.bool,
  toggle: propTypes.func,
  selectedTicket: propTypes.object,
}

export default ModalTicket
